import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function getClientId() {
  let id = localStorage.getItem("ldia_client_id");
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("ldia_client_id", id);
  }
  return id;
}

export const getLead = () => JSON.parse(localStorage.getItem("ldia_lead") || "null");
export const saveLead = (lead) => localStorage.setItem("ldia_lead", JSON.stringify(lead));

export const WHATSAPP_URL = `https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "¡Hola LATINA DIGITAL IA! Quiero información para conseguir más clientes y vender por internet."
)}`;

export const euro = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
